export default {"src":"/_next/static/media/dot-separator.b65c82e5.svg","height":4,"width":5,"blurWidth":0,"blurHeight":0};